import Loader from 'components/molecules/Loader';

interface FileUploadingIndicatorProps {
  progress: number;
}

function FileUploadingIndicator({ progress }: FileUploadingIndicatorProps) {
  return (
    <>
      <Loader color="green" type="small" />
      <span className="text-gray-700">{`File upload progress: ${progress}%`}</span>
    </>
  );
}

export default FileUploadingIndicator;
